import React from 'react'
import './Home_about.css'
import Heading_title from '../../common-components/common-title/heading-title/Heading_title'
import Black_btn from '../../common-components/common-button/black-btn/Black_btn'

const Home_about = () => {
    return (
        <>
            <section className='Home_about_sec'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-md-7 my-auto'>
                            <div className='contsec'>
                                <Heading_title title={'About Us'} subtitle={'Nourishing Nutrition in Every Bite'} />

                                <p className='sbtcont'>Nutripair India was founded with a simple vision — to make healthy, hygienic, and traditional Indian snacks accessible to every corner of the country, not just premium urban markets. We create affordable peanut, millet, and fruit-based snacks and beverages designed for everyday Indian consumers who value both taste and nutrition.
                                </p>
                                <p className='sbtcont'>What makes Nutripair different is our strong distribution-led approach. We focus on building deep market reach across rural towns, kirana stores, industrial belts, modern trade, and online platforms. With partnerships across retail chains like D-Mart, Vishal Mega Mart, Amazon, and Flipkart, we are creating a network that ensures quality products are available wherever consumers are.</p>
                                <br></br>
                                <Black_btn btn_name={'Know More'} btn_link={'/about-us'} />
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='imgsec'>
                                <img className='machineimg' src={process.env.PUBLIC_URL + '/assets/images/home/about/abt-banner.png'} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Home_about